import { type ReactNode } from "react";

import { customTv } from "#utils";
import {
  ToggleButtonGroup as ReactAriaToggleButtonGroup,
  type ToggleButtonGroupProps as ReactAriaToggleButtonGroupProps,
  ToggleButton as ReactAriaToggleButton,
  type ToggleButtonProps as ReactAriaToggleButtonProps,
} from "react-aria-components";

export type { Key, Selection } from "react-aria-components";

export interface ToggleButtonGroupProps extends ReactAriaToggleButtonGroupProps {
  className?: string;
  children?: ReactNode;
}

const toggleButtonGroupStyles = customTv({
  base: "rounded-sm bg-background-secondary p-[.125rem] flex flex-row gap-x-xs w-fit",
});

export function ToggleButtonGroup({ className, ...props }: ToggleButtonGroupProps) {
  return (
    <ReactAriaToggleButtonGroup className={toggleButtonGroupStyles({ className })} {...props}>
      {props.children}
    </ReactAriaToggleButtonGroup>
  );
}

export interface ToggleButtonProps extends ReactAriaToggleButtonProps {
  className?: string;
}

const toggleButtonStyles = customTv({
  base: "rounded-sm px-md py-[.125rem] text-label-medium text-interactive-tertiary-button-enabled-foreground outline-none transition-all ease-in-out data-[selected]:bg-interactive-primary-button-enabled-background data-[selected]:text-interactive-primary-button-enabled-foreground hover:!bg-interactive-primary-button-hover-background hover:text-interactive-primary-button-enabled-foreground font-medium data-[disabled]:cursor-not-allowed data-[disabled]:text-interactive-disabled-foreground data-[disabled]:hover:!bg-transparent data-[disabled]:hover:!text-interactive-disabled-foreground data-[disabled]:data-[selected]:bg-background-tertiary data-[disabled]:data-[selected]:text-interactive-disabled-foreground data-[disabled]:opacity-60 data-[disabled]:data-[selected]:opacity-100",
});

export function ToggleButton({ children, className, ...props }: ToggleButtonProps) {
  return (
    <ReactAriaToggleButton className={toggleButtonStyles({ className })} {...props}>
      {children}
    </ReactAriaToggleButton>
  );
}
